/* eslint-disable no-console */
import { createUpdateSpinner, removeUpdateSpinner } from './components/UpdateSpinner/updateSpinner'

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, { 
    updateViaCache: 'all',     
    ready () {
      console.log('service worker ready');
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading...')
      if (window.navigator.onLine) { createUpdateSpinner(); }
    },
    updated () {
      console.log('New content is available; please refresh.');
      removeUpdateSpinner();
      window.location.reload(true);           
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }    
  })
}
